import { createContainer, style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { PlumaPlainModal } from '@customerio/pluma-components/css/components';

const sheetContainer = createContainer('purchase-sheet');

const TWO_PANE_MIN_WIDTH = '640px';

export const container = style(
  {
    containerName: sheetContainer,
    containerType: 'inline-size',
  },
  'purchase-sheet-container',
);

export const sheet = style(
  {
    display: 'grid',
    gridTemplateColumns: '280px minmax(0, 1fr)',
    gridTemplateAreas: '"rail main"',
    minHeight: '100%',
    '@container': {
      [`${sheetContainer} (max-width: ${TWO_PANE_MIN_WIDTH})`]: {
        gridTemplateColumns: 'minmax(0, 1fr)',
        gridTemplateAreas: '"main" "rail"',
      },
    },
  },
  'purchase-sheet',
);

export const rail = style(
  {
    gridArea: 'rail',
    backgroundColor: themeVars.color['surface-base'],
    borderRight: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
    padding: `${themeVars.space['300']} ${themeVars.space['150']}`,
    '@container': {
      [`${sheetContainer} (max-width: ${TWO_PANE_MIN_WIDTH})`]: {
        borderRight: 'none',
        borderTop: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
      },
    },
  },
  'purchase-sheet-rail',
);

export const railHeading = style({ paddingInline: themeVars.space['100'] }, 'purchase-sheet-rail-heading');

export const railItem = style(
  {
    padding: themeVars.space['100'],
    borderRadius: themeVars.radius['8'],
    selectors: {
      '&:nth-child(odd)': { backgroundColor: themeVars.color['scope-neutral-subtle-bg'] },
    },
  },
  'purchase-sheet-rail-item',
);

export const main = style(
  {
    gridArea: 'main',
    position: 'relative',
    backgroundColor: themeVars.color['surface-content'],
    padding: `${themeVars.space['400']} ${themeVars.space['300']} ${themeVars.space['300']}`,
  },
  'purchase-sheet-main',
);

export const close = style(
  {
    position: 'absolute',
    top: themeVars.space['200'],
    right: themeVars.space['200'],
  },
  'purchase-sheet-close',
);

export const header = style({ textAlign: 'center' }, 'purchase-sheet-header');

export const learnMore = style({ padding: themeVars.space['100'] }, 'purchase-sheet-learn-more');

const DIALOG_MARGIN = themeVars.space['200'];
const transitionDuration = PlumaPlainModal.resolvedVars.plainModalAnimationTransitionDuration;

export const dialog = style(
  {
    display: 'flex',
    flexDirection: 'column',
    width: `min(940px, calc(100vw - 2 * ${DIALOG_MARGIN}))`,
    maxHeight: `calc(100vh - 2 * ${DIALOG_MARGIN})`,
    overflow: 'hidden',
    backgroundColor: themeVars.color['surface-content'],
    borderRadius: themeVars.radius['10'],
    boxShadow: themeVars.depth['surface-3'],
    opacity: 1,
    transform: 'none',
    transition: `opacity ${transitionDuration} ease, transform ${transitionDuration} ${themeVars.motion['easing-entrance-expressive']}`,
    selectors: {
      '&[data-status="initial"], &[data-status="close"]': { opacity: 0, transform: 'scale(0.98)' },
    },
    '@media': {
      '(prefers-reduced-motion: reduce)': { transition: 'none' },
    },
  },
  'purchase-sheet-dialog',
);

export const dialogBody = style(
  {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
  },
  'purchase-sheet-dialog-body',
);

export const loadingDialog = style(
  [
    dialog,
    {
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '320px',
    },
  ],
  'purchase-sheet-loading-dialog',
);
